import { createTheme } from '@mui/material';
import { amber, indigo, red } from '@mui/material/colors';

/**
 * Set up Material Design theme
 */
export const theme = createTheme({
  palette: {
    primary: { main: indigo[500] },
    secondary: { main: amber[500] },
    warning: { main: red[500] },
  },
  // components: {
  //   MuiIconButton: {
  //     defaultProps: {
  //       sx: { background: '#EAAD47' },
  //     },
  //   },
  // },
});

/**
 * Colors
 */
export const themeColors = {
  accent: '#EAAD47',
  gray: '#EAECEF',
  placeholderText: 'rgb(102, 102, 102)',
};

// Used by chart widgets
export const colorPalette = [
  // Indigos
  '#E8EAF6',
  '#C5CAE9',
  '#9FA8DA',
  '#7986CB',
  '#5C6BC0',
  '#316399',
  '#3949AB',
  '#303F9F',
  '#283593',
  '#EAAD47',
  '#FFB300',
  '#FFA000',
  '#FF8F00',
  '#FF6F00',
];
